import { createContext } from 'react';

export type NumericFieldsContextValue = {
  useIncrementers: boolean;
  incrementersLayout?: 'end' | 'around';
};

export const NumericFieldsContext = createContext<NumericFieldsContextValue>({
  useIncrementers: false,
  incrementersLayout: undefined,
});
